import { Control } from 'react-hook-form';
import { realisation as rules } from 'further-ui/validations';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { Card, CardContent, Divider, Typography } from '@mui/material';
import { Column, Row } from 'further-ui/components/Layout';
import { numberToDisplayString } from 'further-ui/utils';
import ManualReceivedConsiderationRow from './ManualReceivedConsiderationRow';
import ManualEscrowConsiderationRow from './ManualEscrowConsiderationRow';
import ManualEarnoutConsiderationRow from './ManualEarnoutConsiderationRow';
import ManualWithholdingTaxConsiderationRow from './ManualWithholdingTaxConsiderationRow';
import ColorIndicatorWithText from 'components/new/ColorIndicatorWithText';

type Props = {
  control: Control<rules.CreateRealisationFormValues>;
  index: number;
  name: string;
  unitsSold: number;
  currencyCode: CurrencyCode;
  disabled: boolean;
};

const ManualConsiderationCard: React.FC<Props> = ({
  control,
  index,
  name,
  unitsSold,
  currencyCode,
  disabled,
}) => {
  return (
    <Card variant="outlined">
      <CardContent>
        <Column spacing="xl">
          <Column spacing="sm">
            <Row justify="space-between" centered>
              <Typography variant="h6">
                <ColorIndicatorWithText colorKey={{ name }} text={name} />
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {numberToDisplayString(unitsSold)} units realised
              </Typography>
            </Row>
            <Divider />
          </Column>

          <ManualReceivedConsiderationRow
            control={control}
            index={index}
            currencyCode={currencyCode}
            disabled={disabled}
          />
          <ManualEscrowConsiderationRow
            control={control}
            index={index}
            currencyCode={currencyCode}
            disabled={disabled}
          />
          <ManualEarnoutConsiderationRow
            control={control}
            index={index}
            currencyCode={currencyCode}
            disabled={disabled}
          />
          <ManualWithholdingTaxConsiderationRow
            control={control}
            index={index}
            currencyCode={currencyCode}
            disabled={disabled}
          />
        </Column>
      </CardContent>
    </Card>
  );
};

export default ManualConsiderationCard;
